module.exports = __webpack_public_path__ + "static/media/PromptingBackground.3ee6d692.png";